import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import {
	EPassengerRouteParams,
	MplButton,
	MplModal,
	usePassengerRoutingHelpers,
} from '@mopla/ui';
import { DTicketExist } from '@mopla/ui/icons/DTicketExist';

export const DTicketExistModal: FC = () => {
	const [openModal, setOpenModal] = useState<boolean>(false);
	const { t } = useTranslation(['dticket']);
	const [query] = useSearchParams();

	const { navigateToDTicketScreen } = usePassengerRoutingHelpers();

	useEffect(() => {
		const subscriptionExists = query.has(
			EPassengerRouteParams.DticketAlreadyExist
		);
		setOpenModal(subscriptionExists);
	}, [query]);

	const closeModal = () => {
		setOpenModal(false);
		navigateToDTicketScreen();
	};

	return (
		<MplModal
			open={openModal}
			icon={<DTicketExist />}
			testId="DTicketExistModal-MplModal"
			title={t('subscription_management.modal.header.subscription_exist')}
			content={t(
				'subscription_management.modal.subscription_exist_description'
			)}
			buttons={
				<MplButton fullWidth onClick={closeModal}>
					{t('subscription_management.button.understand')}
				</MplButton>
			}
		/>
	);
};
